@let desktop = isZeroDesktop() || isFinnetDesktop();
<div class="competitor-analysis" [class.card]="isFinnet() && !desktop">
  <app-v3-competitor-highlights
    [desktop]="desktop"
    [advantage]="advantage()"
    [risk]="risk()"
  ></app-v3-competitor-highlights>

  <div class="section-divider"></div>
  <app-v3-competitor-table
    [peers]="peers()"
    [limit]="limit"
    [desktop]="desktop"
    [finnetMobile]="isFinnet() && !desktop"
    [subject]="desktop ? subject() : null"
    [livePrices]="livePrices"
    (navigateToInstrument)="navigateToInstrument.emit($event)"
  ></app-v3-competitor-table>
</div>
